var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.usuarioLogado.adminWeb)?_c('v-alert',{staticClass:"mb-4",attrs:{"type":"warning","outlined":"","dense":""}},[_vm._v(" Acesso restrito: faça login como administrador para editar questionário. ")]):_c('v-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }